import { createReducer, on } from '@ngrx/store';
import { myInvoicesActions } from '@store/actions/my-invoices.actions';
import { myInvoicesInitialState, MyInvoicesState } from '@store/states/my-invoices.state';

export const myInvoicesReducer = createReducer(
  myInvoicesInitialState,
  on(
    myInvoicesActions.setListingDataFilters,
    (state, { filters }): MyInvoicesState => ({
      ...state,
      listingData: {
        ...state.listingData,
        filters: {
          ...state.listingData.filters,
          ...filters,
        },
      },
    })
  ),
  on(
    myInvoicesActions.setListingData,
    (state, data): MyInvoicesState => ({
      ...state,
      listingData: {
        ...state.listingData,
        data: [...data.data],
        error: null,
      },
    })
  ),
  on(
    myInvoicesActions.setListingDataError,
    (state, { error }): MyInvoicesState => ({
      ...state,
      listingData: {
        ...state.listingData,
        error: error,
      },
    })
  ),
  on(
    myInvoicesActions.filterRequestList,
    (state, { filter }): MyInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        filter,
        page: {
          ...state.requestList.page,
          pageIndex: 1,
        },
      },
    })
  ),
  on(
    myInvoicesActions.pageRequestList,
    (state, { page }): MyInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        page,
      },
    })
  ),
  on(
    myInvoicesActions.sortRequestList,
    (state, { sort }): MyInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        sort,
      },
    })
  ),
  on(
    myInvoicesActions.setRequestListError,
    (state, { error }): MyInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        error,
        data: [],
      },
    })
  ),
  on(
    myInvoicesActions.setRequestList,
    (state, { data }): MyInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        error: null,
        data,
      },
    })
  )
);
